const style = {
    fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
    fontSize: '0.85em',
    padding: '1px 4px',
    background: '#FDECEA',
    color: '#C0392B',
    borderRadius: '4px',
}

const TextEditorCodeLeaf = ({ attributes, children }: any) => (
    <code {...attributes} style={style}>{children}</code>
)

export default TextEditorCodeLeaf
